import { render, staticRenderFns } from "./cNlpMenu.vue?vue&type=template&id=a407f952&scoped=true"
import script from "./cNlpMenu.vue?vue&type=script&lang=js"
export * from "./cNlpMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a407f952",
  null
  
)

export default component.exports